import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from './caravanPrice.scss';
import { calcPrice } from '../../../services/helper';
import Price from '../../util/Price';

function CaravanPrice(props) {
    const { configuration } = props;

    return (
        <div className={style.price}>
            <h2>{t`Schon ab`}</h2>
            <h1><Price value={Math.round(calcPrice(configuration))} /></h1>
            <p>{t`HeadTax`}</p>
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration,
});

export default connect(mapStateToProps, null)(CaravanPrice);
